import React, { useRef, useState } from 'react';
import { Avatar, Badge, Breadcrumb, Button, Card, Checkbox, Col, Divider, Drawer, Dropdown, Flex, Form, Input, Layout, List, message, Pagination, Popconfirm, Row, Select, Steps, Table, Tabs, Tag, theme, Typography } from 'antd';
import { AntDesignOutlined, AppstoreOutlined, CloseOutlined, DeleteOutlined, EditOutlined, EyeOutlined, HomeOutlined, MoreOutlined, PlusOutlined, UserOutlined } from '@ant-design/icons';
import CurrentTeams from '../ApprovalRequest/CurrentTeams';
import CreateTeam from '../ApprovalRequest/CreateTeam';
import { COLOR } from '../../../theme/constant';
import { useSelector } from 'react-redux';

const { Option } = Select;
const { Text } = Typography;

export default function WorkflowManager() {
    const { companyId, token, userCompany, role } = useSelector(state => state.auth);
    const [open, setOpen] = useState(false);
    const createTeamRef = useRef(null)
    const [showInput, setShowInput] = useState(false);
    const [keyRender, setkeyRender] = useState(0);
    const [dataSource, setDataSource] = useState([ // State for table data
        {
            key: '1',
            actionOptions: ['Approve', 'View'],
            name: 'John Doe',
            userOptions: ['User A', 'User B', 'User C', 'User D', 'User E', 'Add Another'],
        },
        {
            key: '2',
            actionOptions: ['Approve', 'View'],
            name: 'Jane Smith',
            userOptions: ['User A', 'User B', 'User C', 'User D', 'User E', 'Add Another'],
        },
        {
            key: '3',
            actionOptions: ['Approve', 'View'],
            name: 'Alice Johnson',
            userOptions: ['User A', 'User B', 'User C', 'User D', 'User E', 'Add Another'],
        },
    ]);

    const defaultTeam = {
        name: "",
        companyId: companyId,
        circulationType: "",
        members: []
    }

    const [nextKey, setNextKey] = useState(4); // For generating unique keys for new rows

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };
    const onCloseatSuccess = () => {
        setOpen(false);
        setkeyRender(keyRender + 1);
    };

    const handleCheckboxChange = (e) => {
        setShowInput(e.target.checked);
    };

    const handleAddUser = () => {
        const newRow = {
            key: nextKey.toString(),
            actionOptions: ['Approve', 'View'],
            name: null, // Name is null initially, will be selected via dropdown
            userOptions: ['User A', 'User B', 'User C', 'User D', 'User E', 'Add Another'],
        };
        setDataSource([...dataSource, newRow]); // Add new row to data source
        setNextKey(nextKey + 1); // Increment key for the next row
    };

    const columns = [
        {
            title: 'Action',
            dataIndex: 'actionOptions',
            key: 'action',
            render: (actionOptions) => (
                <Form.Item style={{ marginBottom: 0 }}>
                    <Select defaultValue={actionOptions[0]} showSearch>
                        {actionOptions.map((action, idx) => (
                            <Select.Option key={idx} value={action}>
                                {action}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (name, record, index) => (
                <Form.Item style={{ marginBottom: 0 }}>
                    <Select
                        variant="borderless"
                        defaultValue={name || 'Select Name'} // Default to "Select Name" if name is null
                        onChange={(value) => {
                            const updatedData = [...dataSource];
                            updatedData[index].name = value; // Update name in the data source
                            setDataSource(updatedData);
                        }}
                    >
                        <Select.Option value="John Doe">John Doe</Select.Option>
                        <Select.Option value="Jane Smith">Jane Smith</Select.Option>
                        <Select.Option value="Alice Johnson">Alice Johnson</Select.Option>
                        <Select.Option value="User A">User A</Select.Option>
                        <Select.Option value="User B">User B</Select.Option>
                        <Select.Option value="User C">User C</Select.Option>
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: 'Alternate Signatory',
            dataIndex: 'userOptions',
            key: 'user',
            render: (userOptions) => (
                <Form.Item style={{ marginBottom: 0 }}>
                    <Select defaultValue={userOptions[0]} showSearch>
                        {userOptions.map((user, idx) => (
                            <Select.Option key={idx} value={user}>
                                {user}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: 'Notification',
            dataIndex: 'NotificationPermissions',
            key: 'Notification Permissions',
            render: () => (
                <Form.Item style={{ marginBottom: 0 }}>
                    <Select showSearch >
                        <Select.Option>
                            1
                        </Select.Option>
                    </Select>
                </Form.Item>
            ),
        },
    ];

    const onChange = (key) => {
        console.log(key);
    };
    const items = [
        {
            key: '1',
            label: 'Current Workflow',
            children: <CurrentTeams />,
        },
        {
            key: '2',
            label: 'Create Workflow',
            children: <CreateTeam />,
        },
    ];

    const [selectedTeam, setSelectedTeam] = useState(null); // State to track the selected team
    const { token: {
        colorBgContainer,
        colorBgSpotlight,
        colorPrimaryBorder,
        colorTextDescription,
        fontSizeSM,
        colorBgElevated,
        borderRadiusLG,
        colorBorder,
        colorTextPlaceholder,
        colorText,
        colorPrimary,
        colorWarning,
        colorError },
    } = theme.useToken();

    const teams = [
        {
            id: 1,
            name: 'Human Resource Team',
            type: 'Parellel',
            color: 'green',
            members: [
                { name: 'A', color: COLOR.alizarin },
                { name: 'K', color: COLOR.amethyst },
                { icon: <UserOutlined />, color: COLOR.asbestos },
                { icon: <AntDesignOutlined />, color: COLOR.belizeHole },
            ],
        },
        {
            id: 2,
            name: 'Marketing Team',
            type: 'Hierarchical',
            color: 'orange',
            members: [
                { name: 'A', color: COLOR.alizarin },
                { name: 'K', color: COLOR.amethyst },
                { icon: <UserOutlined />, color: COLOR.asbestos },
                { icon: <AntDesignOutlined />, color: COLOR.belizeHole },
            ],
        },
    ];

    const dataSource2 = [
        {
            key: '1',
            actionOptions: ['Approve', 'View'], // Dropdown options for the action
            name: 'John Doe',                  // Name of the user
            userOptions: ['User A', 'User B', 'User C', 'User D', 'User E', 'Add Another'], // Dropdown options for the user
        },
        {
            key: '2',
            actionOptions: ['Approve', 'View'],
            name: 'Jane Smith',
            userOptions: ['User A', 'User B', 'User C', 'User D', 'User E', 'Add Another'],
        },
        {
            key: '3',
            actionOptions: ['Approve', 'View'],
            name: 'Alice Johnson',
            userOptions: ['User A', 'User B', 'User C', 'User D', 'User E', 'Add Another'],
        },
    ];

    const columns2 = [
        {
            title: 'Action',
            dataIndex: 'actionOptions',
            key: 'action',
            render: (actionOptions) => (
                <Form.Item style={{ marginBottom: 0 }}>
                    <Select defaultValue={actionOptions[0]} disabled showSearch>
                        {actionOptions.map((action, idx) => (
                            <Select.Option key={idx} value={action}>
                                {action}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Alternate Signatory',
            dataIndex: 'userOptions',
            key: 'user',
            render: (userOptions) => (
                <Form.Item style={{ marginBottom: 0 }}>
                    <Select defaultValue={userOptions[0]} showSearch disabled>
                        {userOptions.map((user, idx) => (
                            <Select.Option key={idx} value={user}>
                                {user}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: 'Notification',
            dataIndex: 'NotificationPermissions',
            key: 'Notification Permissions',
            render: () => (
                <Form.Item style={{ marginBottom: 0 }}>
                    <Select showSearch >
                        <Select.Option>
                            1
                        </Select.Option>
                    </Select>
                </Form.Item>
            ),
        },
    ];


    const renderTeams = () => (
        teams.map((team) => {
            const menuItems = [
                {
                    label: 'View',
                    key: '1',
                    icon: <EyeOutlined />,
                    onClick: () => {
                        // setSelectedTemplate(null);
                        // setSelectedValue(null);
                        // showEditDrawer();
                        // setSelectedEditTemplate(item);
                        setSelectedTeam(team)

                    },
                },
                {
                    label: 'Remove',
                    key: '3',
                    icon: <DeleteOutlined />,
                    onClick: () => {
                        // deleteTemplatebyId(item)

                    },
                }
            ]
            return (
                <>
                    <Flex
                        key={team.id}
                        justify='space-between'
                        align='center'
                        gap={16}
                        style={{
                            padding: '16px 24px',
                            // borderBottom: `1px solid ${colorBorder}`,
                            cursor: 'pointer',
                            marginBottom: '16px',
                            background: colorBgContainer,
                            borderRadius: borderRadiusLG,
                        }}
                    // onClick={() => setSelectedTeam(team)} // Set selected team
                    >
                        <Flex justify='space-between' align='flex-start' vertical gap={4}>
                            <Tag color={team.color}>{team.type}</Tag>
                            <Text strong>{team.name}</Text>
                            <Avatar.Group
                                size={24}
                                max={{
                                    count: 2,
                                    style: {
                                        color: colorText,
                                        backgroundColor: colorPrimary,
                                        fontSize: 12
                                    },
                                }}
                            >
                                {team.members.map((member, index) =>
                                    <Avatar
                                        key={index}
                                        size={24}
                                        style={{ backgroundColor: member.color }}
                                        icon={member.icon || null}
                                    >
                                        {member.name || null}
                                    </Avatar>
                                )}
                            </Avatar.Group>
                        </Flex>
                        <Dropdown
                            menu={{ items: menuItems }}
                            trigger={['click']}
                        >
                            <a onClick={(e) => e.preventDefault()}>
                                <Button icon={<MoreOutlined />} />
                            </a>
                        </Dropdown>
                    </Flex>
                </>
            )
        })
    );

    const renderTeamTable = () => (
        <Card
            bordered={false}
            title={
                <Flex align='center' justify='flex-start' gap={16}>
                    <Button type='text' icon={<CloseOutlined />} onClick={() => setSelectedTeam(null)} />
                    <Text strong>{selectedTeam.name}</Text>
                    <Tag color={selectedTeam.color}>{selectedTeam.type}</Tag>
                </Flex>
            }
            extra={<Button type='primary' icon={<EditOutlined />}> Edit </Button>}
        >
            <Table dataSource={dataSource2} columns={columns2} pagination={false} />
        </Card>
    );


    const saveTeam = () => {
        createTeamRef.current.CreateTeam()
    }

    const refrechfunc = () => {

    }

    return (
        <>
            <Flex gap={20} justify='space-between' align='center' style={{
                margin: '16px',
                padding: '16px 24px',
                // minHeight: 280,
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Breadcrumb
                    items={[
                        {
                            href: '',
                            title: <HomeOutlined />,
                        },
                        {
                            title: 'Workflow Manager',
                        },
                    ]}
                />
                <Flex justify='center' align='center' gap={48}>
                    <Button type="primary" icon={<PlusOutlined />} onClick={showDrawer} >Create New</Button>
                </Flex>

            </Flex>
            <div style={{
                margin: '16px',
                padding: '16px 24px',
                // minHeight: 280,
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <CurrentTeams key={keyRender} refreshfunc={refrechfunc} />
                {/* Use if only exceeded 10 items */}
                {/* <Pagination align="end" defaultCurrent={1} total={50} /> */}
            </div>
            {/* <div style={{
                margin: '16px',
                padding: '16px 24px',
                // minHeight: 280,
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Form layout='vertical'>
                    <Row gutter={16}>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                            <Form.Item label="Circuler Type">
                                <Select>
                                    <Select.Option value="Parallel">Parallel</Select.Option>
                                    <Select.Option value="Hierarchical">Hierarchical</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                            <Form.Item label="Select Workflow">
                                <Select showSearch>
                                    <Select.Option value="TeamA">Team A</Select.Option>
                                    <Select.Option value="TeamB">Team B</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div style={{
                margin: '16px',
            }}>
                {selectedTeam ? renderTeamTable() : renderTeams()}
            </div> */}


            <Drawer
                title="Create Workflow"
                onClose={onClose}
                open={open}
                size='large'
                destroyOnClose={true}
                footer={[
                    <Flex justify='flex-end' align='center' gap='large'>
                        <Button onClick={onClose}>
                            Cancel
                        </Button>
                        <Button type="primary" onClick={saveTeam}>
                            Save
                        </Button>
                    </Flex>
                ]}
            >
                <CreateTeam setTeam={undefined} initialTeam={defaultTeam} showTeamNameField={true} drawerClose={onCloseatSuccess} selectTeam={[]} hocusers={{}} ref={createTeamRef} />
            </Drawer>

        </>
    );
}
